module.exports = __webpack_public_path__ + "img/body-1-lg.8ba3cb01.png";